<div
  class="toast {{ type }} toast--visible"
  [ngClass]="{ 
    'toast--visible': isVisible, 
    'toast--fullscreen': isFullScreen,
    'toast--centered': isCentered 
  }">
  
  <div [innerHtml]="text"></div>
  
  <div
    *ngIf="!isCloseDisabled"
    class="toast_icon"
    (click)="onClose()">
    <fa-icon [icon]="['fal', 'times']"></fa-icon>
  </div>

  <div
    *ngIf="confirmButton || cancelButton"
    class="toast_button-box">
    <div
      *ngIf="confirmButton"
      class="button-primary button-primary--sm button-primary--transparent"
      (click)="onConfirmClick()">
      {{ confirmButton.text }}
    </div>
    <div 
      *ngIf="cancelButton"
      class="button-primary button-primary--sm button-primary--transparent"
      (click)="onCancelClick()">
      {{ cancelButton.text }}
    </div>
  </div>
</div>
